module.exports = __webpack_public_path__ + "img/cq-tab-icon2.81f079f6.png";